import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-690e1f8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-product-info-block"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "blocked-text",
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = {
  class: "blocked-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "block-button",
    id: $props.item_id,
    onClick: _cache[0] || (_cache[0] = () => {
      _ctx.$emit('block-toggled');
    }),
    onMouseenter: _cache[1] || (_cache[1] = () => {
      $data.blockIconOver = true;
    }),
    onMouseleave: _cache[2] || (_cache[2] = () => {
      $data.blockIconOver = false;
    })
  }, [_createVNode(_component_app_icon, {
    icon: "blocked",
    size: 16,
    color: $options.getBlockIconColor
  }, null, 8, ["color"])], 40, _hoisted_2), _createVNode(_component_app_popover, {
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString($data.popoverMap[$props.is_blocked]?.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($data.popoverMap[$props.is_blocked]?.description), 1)]),
    _: 1
  }, 8, ["target"])]);
}